import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InputStatesService {
  cachedSearchValues: Record<string, any> = {};

  getStoredSearchTerm(identifier: string): string {
    return this.cachedSearchValues[identifier] ?? '';
  }

  storeSearchTerm(identifier: string, searchTerm: string): void {
    this.cachedSearchValues[identifier] = searchTerm;
  }

  resetState(): void {
    this.cachedSearchValues = {};
  }
}
